import React, { useState } from 'react';

import SelectionList from '@vfgroup-oneplatform/foundation/Components/SelectionList';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import style from './ChooseDurationSectionStyle';

const ChooseDurationSection = ({ theme, onSelectOption, instalmentPlans }) => {
  const [selectedIndex, setSelectedIndex] = useState(undefined);
  const onOptionChange = (index, data) => {
    setSelectedIndex(index);
    _isFunction(onSelectOption) && onSelectOption({ index, data });
  };
  return (
    <SelectionList
      options={instalmentPlans}
      initialSelectedIndex={selectedIndex}
      onSelectOption={onOptionChange}
      contentContainerStyle={style.contentContainerStyle}
      itemContainerStyle={style.selectionListContainerStyle(theme)}
      activeTitleStyle={style.selectionListTitleStyle(theme)}
      inActiveTitleStyle={style.selectionListTitleStyle(theme)}
      activeSubtitleStyle={style.selectionListSubTitleStyle(theme)}
      inActiveSubtitleStyle={style.selectionListSubTitleStyle(theme)}
      withInitialScrollToIndex
      itemWidth={152}
    />
  );
};
ChooseDurationSection.defaultProps = {
  instalmentPlans: [
    { title: '2 months', subTitle: '25.00/month' },
    { title: '3 months', subTitle: '16.66/month' },
    { title: '4 months', subTitle: '12.50/month' },
  ],
};

ChooseDurationSection.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  onSelectOption: PropTypes.func,
  instalmentPlans: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.string,
    }),
  ),
};

export default ChooseDurationSection;
